module.exports = __webpack_public_path__ + "img/ShipStation-logo-black-1024x173.b126cdb5.png";